import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'

import FormLocationAutosuggestLoader from '../AutosuggestLoader/index.js'
import FormLocationRadio from '../Radio/index.js'
import {AUTOSUGGEST_COMPONENTS_BY_DESIGN} from './config.js'

const FormLocationSearch = ({autoFocus, design, isLoading, onChange, search}) => {
  const {domain} = useSuiContext()

  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const {DEFAULT_LOCATION_MIN_RADIO} = config.get('search')

  const {text, radio} = search[FILTER_NAMES.LOCATION]

  const hasLocation = Boolean(text)

  const LocationAutosuggestComponent = AUTOSUGGEST_COMPONENTS_BY_DESIGN[design] || FormLocationAutosuggestLoader

  const handleChangeLocationSearch = ({lastFilter, value}) => {
    onChange('', {
      field: FILTER_NAMES.LOCATION,
      value,
      lastFilter
    })
  }

  const handleSelectLocation = ({lat, long, text, provinceId}) =>
    handleChangeLocationSearch({
      value: {...search[FILTER_NAMES.LOCATION], lat, long, radio: DEFAULT_LOCATION_MIN_RADIO, text, provinceId},
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.LOCATION_TEXT]
    })

  const handleChangeRadio = ({radio}) => {
    handleChangeLocationSearch({
      value: {...search[FILTER_NAMES.LOCATION], radio},
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.LOCATION_RADIO]
    })
  }

  return (
    <>
      <LocationAutosuggestComponent
        autoFocus={autoFocus}
        isLoading={isLoading}
        onChange={handleSelectLocation}
        value={text}
      />
      <FormLocationRadio isDisabled={!hasLocation} value={radio} onChange={handleChangeRadio} />
    </>
  )
}

FormLocationSearch.displayName = 'FormLocationSearch'
FormLocationSearch.propTypes = {
  autoFocus: PropTypes.bool,
  design: PropTypes.string,
  isLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  search: PropTypes.arrayOf(PropTypes.number)
}

export default FormLocationSearch
